/* Menu Entry Template:
{
  name: 'Name that appears in menu',
  id: 'Unique identifier for specific tile',
  content: [{
    id: 'data-src-ID',
    type: 'line/bar/dotplot/table/image'
  }],
  components: ['toggles', 'tabs']
},
*/

export default {
  label: "Tones 5",
  id: 'tones-5',
  sidebar: [
    {
      li: 'Study Overview',
      subList: [
        {
          name: 'Summary',
          tileId: 'tones-5-summary',
          content: [{
            id: 'tones-5-summary',
            type: 'image'
          }],
          components: []
        },
        {
          name: 'Study Design',
          tileId: 'tones-5-study-design',
          content: [{
            id: 'tones-5-study-design',
            type: 'image'
          }],
          tooltip: `<p>Inclusion Criteria: usual nightly sleep of at least 6 h; BMI of 18 to <45 kg/m<sup>2</sup>; OSA studies – participants with current or
          prior use of primary OSA therapy, participants without current primary OSA therapy use or a history of surgical intervention for OSA were required to
          have tried to use primary OSA therapy for at least 1 month with at least one documented adjustment to the therapy; narcolepsy studies – use of anticataplectic
          medications was allowed, including selective serotonin reuptake inhibitors, serotonin-norepinephrine reuptake inhibitors, and tricyclic antidepressants.</p>

          <p>Exclusion Criteria: similar to those previously reported for parent studies; characteristics either associated with EDS or that could affect evaluation of
          EDS; patients in previous studies who experience any serious AE that was deemed related to solriamfetol or TEAE that might prevent safe participation in this
          study; use of any over-the-counter or prescription medication (eg, stimulants, modafinil, sodium oxybate) that could affect evaluation of EDS.</p>`,
          components: []
        },
        {
          name: 'Participant Disposition',
          tileId: 'tones-5-participant-disposition',
          content: [{
            id: 'tones-5-participant-disposition',
            type: 'image'
          }],
          components: []
        },
        {
          name: 'Baseline Characteristics',
          tileId: 'tones-5-baseline-characteristics',
          content: [{
            id: 'tones-5-baseline-char',
            type: 'table'
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
      ],
    },
    {
      li: 'Efficacy',
      subList: [
        {
          name: 'ESS: RW Phase',
          tileId: 'tones-5-ess-rwp',
          content: [{
            id: 'tones-5-ess-mitt-rwp',
            type: 'line'
          }],
          components: []
        },
        {
          name: 'PGI-C and CGI-C',
          tileId: 'tones-5-pci-g-and-cgi-c',
          content: [{
            id: 'tones-5-pgic-cgic',
            type: 'bar'
          }],
          components: []
        },
        {
          name: 'ESS: Group A',
          tileId: 'tones-5-ess-group-a',
          content: [{
            id: 'tones-5-ess-groupa',
            type: 'line'
          }],
          components: ['toggles']
        },
        {
          name: 'ESS: Group B',
          tileId: 'tones-5-ess-group-b',
          content: [{
            id: 'tones-5-ess-groupb',
            type: 'line'
          }],
          components: ['toggles'],
        },
      ],
    },
    {
      li: 'Safety',
      subList: [
        {
          name: 'TEAEs',
          tileId: 'tones-5-teaes',
          content: [{
            id: 'tones-5-teaes',
            type: 'table',
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
        {
          name: 'Primary Therapy Adherence',
          tileId: 'tones-5-cpap-adherence',
          content: [{
            id: 'tones-5-cpap-adh',
            type: 'table',
          }],
          components: [],
          hideTopScrollEffect: true,
          hideLeftScrollEffect: true,
        },
      ],
    },
  ],
};
